/* eslint-disable */
import Api from '@/services/Api'

export default {
    allClasses(data){
        try {
           return Api().get('classrooms/all/');
        }catch(err){
            console.log(err);
            return err
        }
    },
    create(data){
        try {
           return Api().post('classrooms/create/', data);
        }catch(err){
            console.log(err);
            return err
        }
    },
    createCourseWork(data){
        try {
           return Api().post('classrooms/coursework/create/', data);
        }catch(err){
            console.log(err);
            return err
        }
    },
    addGSheet(data){
        try {
           return Api().post('classrooms/gsheet/create/', data);
        }catch(err){
            console.log(err);
            return err
        }
    },
    getGSheetCourseWorkRecords(data){
        try {
           return Api().get('classrooms/gsheet/coursework/');
        }catch(err){
            console.log(err);
            return err
        }
    },
    updateCourseWorkRecords(data){
        try {
            return Api().get('classrooms/gsheet/coursework/update');
        }catch(err){
            console.log(err);
            return err
        }
    },
    createMassCourseWork(data){
        try {
           return Api().get('classrooms/gsheet/coursework/mass');
        }catch(err){
            console.log(err);
            return err
        }
    },
    getCourseTeachers(data){
        try {
            return Api().get('classrooms/gsheet/course/teachers');
        }catch(err){
            console.log(err);
            return err
        }
    },
    UpdateCourseTeachers(data){
        try {
           return Api().get('classrooms/gsheet/course/teachers/resync');
        }catch(err){
            console.log(err);
            return err
        }
    },
    getCourseStudent(data){
        try {
           return Api().get('classrooms/gsheet/course/students');
        }catch(err){
            console.log(err);
            return err
        }
    },
    updateCourseStudent(data){
        try {
           return Api().get('classrooms/gsheet/course/students/resync');
        }catch(err){
            console.log(err);
            return err
        }
    },
    allTopics(data){
        try {
           return Api().get('classrooms/topics/');
        }catch(err){
            console.log(err);
            return err
        }
    },
    updateTopics(data){
        try {
            return Api().get('classrooms/topics/update');
        }catch(err){
            console.log(err);
            return err
        }
    },
}
